import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Checkbox, Dropdown, Input, Radio } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    hdsVodCont: boolean;
    hdsStreamIdReq: boolean;
    hdsRedirectManifest: boolean;
    hdsRedirectMedia: boolean;
    hdsRedirectBootstrap: boolean;
    hdsShareConn: boolean;
    hdsPersistConn: boolean;
    hdsCookieMode: boolean;
    hdsManifestGzip: boolean;
    hdsBootstrapGzip: boolean;
    hdsMediaGetIvl: any;
    hdsAutoStartComp: string;
    hdsAutoStartCompLimitVar: string;
    hdsVarNameOptPatternMatch: boolean;
    hdsDecrypt: boolean;
    hdsPersistConnTimeout: any;
    hdsQoeAllVideo: boolean;
    hdsQoeAllAudio: boolean;
    hdsQoeAllPixel: boolean;
    hdsQoeLimitVideo: boolean;
    hdsQoeLimitAudio: boolean;
    hdsQoeLimitPixel: boolean;
}

interface Props {

}

export default class AdobeStreamConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            hdsVodCont: false,
            hdsStreamIdReq: false,
            hdsRedirectManifest: false,
            hdsRedirectMedia: false,
            hdsRedirectBootstrap: false,
            hdsShareConn: false,
            hdsPersistConn: false,
            hdsCookieMode: false,
            hdsManifestGzip: false,
            hdsBootstrapGzip: false,
            hdsMediaGetIvl: '',
            hdsAutoStartComp: '',
            hdsAutoStartCompLimitVar: '',
            hdsVarNameOptPatternMatch: false,
            hdsDecrypt: false,
            hdsPersistConnTimeout: '',
            hdsQoeAllVideo: false,
            hdsQoeAllAudio: false,
            hdsQoeAllPixel: false,
            hdsQoeLimitVideo: false,
            hdsQoeLimitAudio: false,
            hdsQoeLimitPixel: false
        });

        this.fetchData();
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {},
            options: [
                'hdsVodCont', 'hdsStreamIdReq', 'hdsRedirectManifest', 'hdsRedirectMedia', 'hdsRedirectBootstrap',
                'hdsShareConn', 'hdsPersistConn', 'hdsCookieMode', 'hdsManifestGzip', 'hdsBootstrapGzip',
                'hdsMediaGetIvl', 'hdsAutoStartComp', 'hdsAutoStartCompLimitVar', 'hdsVarNameOptPatternMatch', 'hdsDecrypt',
                'hdsPersistConnTimeout', 'hdsQoeAllVideo', 'hdsQoeAllAudio', 'hdsQoeAllPixel', 'hdsQoeLimitVideo', 'hdsQoeLimitAudio', 'hdsQoeLimitPixel'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        hdsVodCont: responseObject[0].value,
                        hdsStreamIdReq: responseObject[1].value,
                        hdsRedirectManifest: responseObject[2].value,
                        hdsRedirectMedia: responseObject[3].value,
                        hdsRedirectBootstrap: responseObject[4].value,
                        hdsShareConn: responseObject[5].value,
                        hdsPersistConn: responseObject[6].value,
                        hdsCookieMode: responseObject[7].value,
                        hdsManifestGzip: responseObject[8].value,
                        hdsBootstrapGzip: responseObject[9].value,
                        hdsMediaGetIvl: responseObject[10].value,
                        hdsAutoStartComp: responseObject[11].value,
                        hdsAutoStartCompLimitVar: responseObject[12].value,
                        hdsVarNameOptPatternMatch: responseObject[13].value,
                        hdsDecrypt: responseObject[14].value,
                        hdsPersistConnTimeout: responseObject[15].value,
                        hdsQoeAllVideo: responseObject[16].value,
                        hdsQoeAllAudio: responseObject[17].value,
                        hdsQoeAllPixel: responseObject[18].value,
                        hdsQoeLimitVideo: responseObject[19].value,
                        hdsQoeLimitAudio: responseObject[20].value,
                        hdsQoeLimitPixel: responseObject[21].value
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {},
            options: [
                {'name': 'hdsVodCont', 'value': this.state.hdsVodCont},
                {'name': 'hdsStreamIdReq', 'value': this.state.hdsStreamIdReq},
                {'name': 'hdsRedirectManifest', 'value': this.state.hdsRedirectManifest},
                {'name': 'hdsRedirectMedia', 'value': this.state.hdsRedirectMedia},
                {'name': 'hdsRedirectBootstrap', 'value': this.state.hdsRedirectBootstrap},
                {'name': 'hdsShareConn', 'value': this.state.hdsShareConn},
                {'name': 'hdsPersistConn', 'value': this.state.hdsPersistConn},
                {'name': 'hdsCookieMode', 'value': this.state.hdsCookieMode},
                {'name': 'hdsManifestGzip', 'value': this.state.hdsManifestGzip},
                {'name': 'hdsBootstrapGzip', 'value': this.state.hdsBootstrapGzip},
                {'name': 'hdsMediaGetIvl', 'value': this.state.hdsMediaGetIvl},
                {'name': 'hdsAutoStartComp', 'value': this.state.hdsAutoStartComp},
                {'name': 'hdsAutoStartCompLimitVar', 'value': this.state.hdsAutoStartCompLimitVar},
                {'name': 'hdsVarNameOptPatternMatch', 'value': this.state.hdsVarNameOptPatternMatch},
                {'name': 'hdsDecrypt', 'value': this.state.hdsDecrypt},
                {'name': 'hdsPersistConnTimeout', 'value': this.state.hdsPersistConnTimeout},
                {'name': 'hdsQoeAllVideo', 'value': this.state.hdsQoeAllVideo},
                {'name': 'hdsQoeAllAudio', 'value': this.state.hdsQoeAllAudio},
                {'name': 'hdsQoeAllPixel', 'value': this.state.hdsQoeAllPixel},
                {'name': 'hdsQoeLimitVideo', 'value': this.state.hdsQoeLimitVideo},
                {'name': 'hdsQoeLimitAudio', 'value': this.state.hdsQoeLimitAudio},
                {'name': 'hdsQoeLimitPixel', 'value': this.state.hdsQoeLimitPixel}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Adobe / HTTP Dynamic Streaming configuration applied');
                } else {
                    Toast.error('Adobe / HTTP Dynamic Streaming configuration failed');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Adobe / HTTP Dynamic Streaming configuration failed');
            });
    }

    toggleVideo(index: any) {
        if (index === 1) {
            if (this.state.hdsQoeAllVideo) {
                this.setState({hdsQoeAllVideo: false, hdsQoeAllPixel: false});
            } else {
                this.setState({hdsQoeAllVideo: true});
            }
        } else {
            if (this.state.hdsQoeLimitVideo) {
                this.setState({hdsQoeLimitVideo: false, hdsQoeLimitPixel: false});
            } else {
                this.setState({hdsQoeLimitVideo: true});
            }
        }
    }

    render() {
        const mediaIvlOptions = [
            {value: 'disabled', text: 'disabled'},
            {value: 25, text: '25'},
            {value: 50, text: '50'},
            {value: 100, text: '100'}
        ];

        const hdsStreamingOptions = [
            {stateName: 'hdsStreamIdReq', label: 'Include Stream Identifier Cookie In HTTP Requests'},
            {stateName: 'hdsRedirectManifest', label: 'Enable Manifest Redirect'},
            {stateName: 'hdsRedirectMedia', label: 'Enable Media Redirect'},
            {stateName: 'hdsRedirectBootstrap', label: 'Enable Bootstrap Redirect'},
            {stateName: 'hdsShareConn', label: 'Enable Shared Manifest/Bootstrap/Media Connections'},
            {stateName: 'hdsPersistConn', label: 'Enable Persistent Connections'},
            {stateName: 'hdsDecrypt', label: 'Enable Decryption'},
            {stateName: 'hdsCookieMode', label: 'Enable Cookies'},
            {stateName: 'hdsManifestGzip', label: 'Enable Manifest GZIP Compression'},
            {stateName: 'hdsBootstrapGzip', label: 'Enable Bootstrap GZIP Compression'}
        ];

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    Adobe/HTTP Dynamic Streaming
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Streaming Options</Segment>
                                    <Segment>
                                        <Form>
                                            {/*{!oauth.VODOnlyLicensePresent ?*/}
                                            {/*<Form.Group grouped>*/}
                                            {/*    <Label className="right-align-label-width500">*/}
                                            {/*        Play VOD Streams Continuously*/}
                                            {/*    </Label>*/}
                                            {/*    <Checkbox*/}
                                            {/*        className="config-checkbox"*/}
                                            {/*        checked={this.state.hdsVodCont}*/}
                                            {/*        onChange={(e: any, data: any) => this.setState({hdsVodCont: data.checked})}*/}
                                            {/*    />*/}
                                            {/*</Form.Group>*/}
                                            {/*: null}*/}
                                            {hdsStreamingOptions.map((streamingOption, index) => {
                                                return <Form.Group grouped key={streamingOption.stateName}>
                                                    <Checkbox
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state[streamingOption.stateName]}
                                                        onChange={(e: any, data: any) => this.setState({
                                                            ...this.state,
                                                            [streamingOption.stateName]: data.checked
                                                        })}
                                                    />
                                                    <Label
                                                        className={(streamingOption.stateName === 'hdsPersistConn') ? 'left-align-label-min150' : 'left-align-label-500'}
                                                    >
                                                        {streamingOption.label}
                                                    </Label>
                                                    {streamingOption.stateName === 'dashPersistConn' &&
                                                    <>
                                                        <Label
                                                            className={!this.state.hdsPersistConn ? 'right-align-label-width170 label-disabled' : 'right-align-label-width170'}
                                                        >
                                                            Timeout (seconds)
                                                        </Label>
                                                        <Input
                                                            className="small-input"
                                                            disabled={!this.state.hdsPersistConn}
                                                            type="number"
                                                            min="0"
                                                            max="600"
                                                            value={this.state.hdsPersistConnTimeout}
                                                            onChange={(e: any, data: any) => this.setState({hdsPersistConnTimeout: data.value})}
                                                        />
                                                    </>
                                                    }
                                                </Form.Group>;
                                            })}
                                            <Form.Group grouped>
                                                <Label className="left-align-label-min200" style={{paddingLeft: '10%'}}>
                                                    Maximum Media File Requests Per Manifest File Request
                                                </Label>
                                                <Dropdown
                                                    className="dropDown"
                                                    search
                                                    value={this.state.hdsMediaGetIvl}
                                                    options={mediaIvlOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({hdsMediaGetIvl: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Variant Name Options</Segment>
                                    <Segment>
                                        <Checkbox
                                            className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                            checked={this.state.hdsVarNameOptPatternMatch}
                                            onChange={(e: any, data: any) => this.setState({hdsVarNameOptPatternMatch: data.checked})}
                                        />
                                        <Label className="left-align-label-500" style={{width: 347}}>
                                            Pattern Match
                                        </Label>
                                    </Segment>
                                    <Segment className="segment-header">Auto-Start Variant Streams</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="Disable"
                                                    name="radioGroup"
                                                    value="disabled"
                                                    checked={this.state.hdsAutoStartComp === 'disabled'}
                                                    onChange={(e: any, data: any) => this.setState({hdsAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="All"
                                                    name="radioGroup"
                                                    value="all"
                                                    checked={this.state.hdsAutoStartComp === 'all'}
                                                    onChange={(e: any, data: any) => this.setState({hdsAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    {/*<Label className="left-align-label-85"/>*/}
                                                    <Checkbox
                                                        disabled={this.state.hdsAutoStartComp !== 'all'}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hdsQoeAllVideo}
                                                        // onChange={(e: any, data: any) => this.setState({hdsQoeAllVideo: data.checked})}
                                                        onChange={(event: any) => this.toggleVideo(1)}
                                                    />
                                                    <Label
                                                        className={(this.state.hdsAutoStartComp !== 'all')
                                                            ? 'left-align-label-min240-disabled'
                                                            : 'left-align-label-min240'
                                                        }
                                                    >
                                                        Content Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    {/*<Label className="left-align-label-85"/>*/}
                                                    <Checkbox
                                                        disabled={(this.state.hdsAutoStartComp !== 'all') || (!oauth.QoELicensePresent) || (!this.state.hdsQoeAllVideo ? true : false)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hdsQoeAllPixel}
                                                        onChange={(e: any, data: any) => this.setState({hdsQoeAllPixel: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hdsAutoStartComp !== 'all') || (!oauth.QoELicensePresent) || (!this.state.hdsQoeAllVideo ? true : false)
                                                            ? 'left-align-label-min240-disabled'
                                                            : 'left-align-label-min240'
                                                        }
                                                    >
                                                        Pixel Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    {/*<Label className="left-align-label-85"/>*/}
                                                    <Checkbox
                                                        disabled={this.state.hdsAutoStartComp !== 'all'}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hdsQoeAllAudio}
                                                        onChange={(e: any, data: any) => this.setState({hdsQoeAllAudio: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hdsAutoStartComp !== 'all')
                                                            ? 'left-align-label-min240-disabled'
                                                            : 'left-align-label-min240'
                                                        }
                                                    >
                                                        Audio Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width"/>
                                                <Radio
                                                    label="Limited"
                                                    name="radioGroup"
                                                    value="limited"
                                                    checked={this.state.hdsAutoStartComp === 'limited'}
                                                    onChange={(e: any, data: any) => this.setState({hdsAutoStartComp: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label
                                                    className={(this.state.hdsAutoStartComp !== 'limited')
                                                        ? 'right-align-label-width180-disabled'
                                                        : 'right-align-label-width180'
                                                    }
                                                >
                                                    Variants
                                                </Label>
                                                <Input
                                                    disabled={this.state.hdsAutoStartComp !== 'limited'}
                                                    maxLength={63}
                                                    className="small-input-leftMargin"
                                                    value={this.state.hdsAutoStartCompLimitVar}
                                                    onChange={(e: any, data: any) => this.setState({hdsAutoStartCompLimitVar: data.value})}
                                                />
                                            </Form.Group>
                                            <OAuth.Feature QoE>
                                                <Form.Group grouped>
                                                    <Checkbox
                                                        disabled={this.state.hdsAutoStartComp !== 'limited'}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hdsQoeLimitVideo}
                                                        // onChange={(e: any, data: any) => this.setState({hdsQoeLimitVideo: data.checked})}
                                                        onChange={(event: any) => this.toggleVideo(2)}
                                                    />
                                                    <Label
                                                        className={(this.state.hdsAutoStartComp !== 'limited')
                                                            ? 'left-align-label-min240-disabled'
                                                            : 'left-align-label-min240'
                                                        }
                                                    >
                                                        Content Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Checkbox
                                                        disabled={(this.state.hdsAutoStartComp !== 'limited') || (!oauth.QoELicensePresent) || (!this.state.hdsQoeLimitVideo ? true : false)}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hdsQoeLimitPixel}
                                                        onChange={(e: any, data: any) => this.setState({hdsQoeLimitPixel: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hdsAutoStartComp !== 'limited') || (!oauth.QoELicensePresent) || (!this.state.hdsQoeLimitVideo ? true : false)
                                                            ? 'left-align-label-min240-disabled'
                                                            : 'left-align-label-min240'
                                                        }
                                                    >
                                                        Pixel Analysis
                                                    </Label>
                                                </Form.Group>
                                                <Form.Group grouped>
                                                    <Checkbox
                                                        disabled={this.state.hdsAutoStartComp !== 'limited'}
                                                        className="config-checkbox-left paddingLeft-5 paddingRight-20"
                                                        checked={this.state.hdsQoeLimitAudio}
                                                        onChange={(e: any, data: any) => this.setState({hdsQoeLimitAudio: data.checked})}
                                                    />
                                                    <Label
                                                        className={(this.state.hdsAutoStartComp !== 'limited')
                                                            ? 'left-align-label-min240-disabled'
                                                            : 'left-align-label-min240'
                                                        }
                                                    >
                                                        Audio Analysis
                                                    </Label>
                                                </Form.Group>
                                            </OAuth.Feature>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/adobeStreamConfig.tsx